import moment from 'moment';

export const getTotalPrice = (flatPrice, skipassPrice, capacity) => (flatPrice + skipassPrice * capacity) / 100;

export const calculateDeadlineDueDate = (postBookingDays, preEventDays, beginDate) => {
  if (!preEventDays) {
    return moment().add(postBookingDays, 'days');
  }
  if (!postBookingDays) {
    return moment(beginDate).subtract(preEventDays, 'days');
  }
  const postBookingDate = moment().add(postBookingDays, 'days');
  const preEventDate = moment(beginDate).subtract(preEventDays, 'days');
  return postBookingDate < preEventDate ? postBookingDate : preEventDate;
};

export const getInstalment = (data, crew, percentage) => (
  getTotalPrice(data, crew) * percentage
);

export const countAvailableProductsOnWeek = week => (
  countAvailableFlatsOnWeek(week)
  + countAvailableRoomsOnWeek(week)
  + countAvailableSoloSpotsOnWeek(week)
);

export const countAvailableFlatsOnWeek = week => (
  week.flatTypes ? week.flatTypes.reduce((acc, ft) => acc + ft.availability, 0) : 0
);

export const countAvailableRoomsOnWeek = week => (
  week.rooms.enabled ? week.rooms.availability : 0
);

export const countAvailableSoloSpotsOnWeek = week => (
  week.solo.enabled ? week.solo.availability : 0
);

export const calculateMinPriceOnDestinationPerPerson = destination => (
  destination.weeks.filter(w => !w.invisible).filter(w => !['sold_out', 'closed', 'coming_soon'].includes(w.status))
    .map(w => calculateMinPriceOnWeekPerPerson(w)).reduce((min, cur) => Math.min(min, cur), Infinity)
);

export const calculateMinPriceOnWeekPerPerson = week => {
  const flatPrice = calculateMinFlatPriceOnWeekPerPerson(week);
  const roomPrice = getRoomPriceOnWeekPerPerson(week);
  const soloPrice = getSoloPriceOnWeek(week);
  return Math.min(...[flatPrice, roomPrice, soloPrice].filter(p => !!p));
};

export const calculateMinFlatPriceOnWeekPerPerson = week => {
  const availableFlatTypes = week.flatTypes.filter(ft => ft.availability > 0);
  return availableFlatTypes? Math.min(...availableFlatTypes.map(ft => (ft.price / ft.capacity) + week.skipassPrice)): null;
};

export const getRoomPriceOnWeekPerPerson = week => (
  week.rooms.enabled && week.rooms.availability > 0? (week.rooms.price / 2) + week.skipassPrice: null
);

export const getSoloPriceOnWeek = week => (
  week.solo.enabled && week.solo.availability > 0? week.solo.price + week.skipassPrice: null
);
